import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
// import QueueAnim from 'rc-queue-anim';
import { Button, Result } from 'antd';
import { useRouteError } from "react-router-dom";
const ErrorPage = () => {
    const error = useRouteError();
    { /* 404 errors are handled in 404.tsx*/ }
    return (_jsxs("div", { className: "page-err", children: [_jsx(Result, { status: 500, title: "Oops, this is embarrassing", subTitle: (_jsxs(_Fragment, { children: ["Please take a screenshot of this error and email it to\u00A0", _jsx("u", { children: _jsx("a", { target: "_blank", href: "mailto:tech-support@subtrux.com", children: "SubTrux tech support" }) })] })), extra: _jsx(Button, { type: "primary", href: "/", children: "Home" }) }), _jsx("pre", { style: { width: "500px", margin: "0 auto" }, children: error.stack })] }));
};
export default ErrorPage;
